import React, { FunctionComponent, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

const StyledContainer = styled(Box)`
  display: flex;
`;

const ExclamationCircle: FunctionComponent = () => {
  const theme = useContext(ThemeContext);
  const color = theme.colors["secondary-orange"];

  return (
    <StyledContainer data-testid="exclamation-circle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M12 2.5C6.47754 2.5 2 6.97915 2 12.5C2 18.0241 6.47754 22.5 12 22.5C17.5225 22.5 22 18.0241 22 12.5C22 6.97915 17.5225 2.5 12 2.5ZM12 20.5645C7.54306 20.5645 3.93548 16.9584 3.93548 12.5C3.93548 8.04456 7.54323 4.43548 12 4.43548C16.4553 4.43548 20.0645 8.04319 20.0645 12.5C20.0645 16.9569 16.4584 20.5645 12 20.5645ZM13.6935 16.371C13.6935 17.3048 12.9338 18.0645 12 18.0645C11.0662 18.0645 10.3065 17.3048 10.3065 16.371C10.3065 15.4371 11.0662 14.6774 12 14.6774C12.9338 14.6774 13.6935 15.4371 13.6935 16.371ZM10.4125 7.84673L10.6867 13.3306C10.6996 13.5881 10.9121 13.7903 11.17 13.7903H12.83C13.0879 13.7903 13.3004 13.5881 13.3133 13.3306L13.5875 7.84673C13.6013 7.57036 13.381 7.33871 13.1042 7.33871H10.8958C10.619 7.33871 10.3987 7.57036 10.4125 7.84673Z"
          fill={color}
        />
      </svg>
    </StyledContainer>
  );
};

export default ExclamationCircle;
